"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitUntilOnline = exports.addOnlineEventListener = exports.isOnline = void 0;
function isOnline() {
    return window.navigator.onLine;
}
exports.isOnline = isOnline;
function addOnlineEventListener(callback) {
    var evtName = "online";
    var handleOnline = function () {
        window.removeEventListener(evtName, handleOnline);
        callback();
    };
    window.addEventListener(evtName, handleOnline);
}
exports.addOnlineEventListener = addOnlineEventListener;
function waitUntilOnline() {
    return new Promise(function (resolve) {
        addOnlineEventListener(resolve);
    });
}
exports.waitUntilOnline = waitUntilOnline;
//# sourceMappingURL=network.js.map